import React, { useCallback } from "react";

import {
  AudioTestState,
  DeviceTesterTestState,
} from "../../../types/Device.types";
import { DeviceStatus } from "../../results/results-view/ResultsView.types";
import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import { useDeviceTesterDispatchContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { logAudioTestResult } from "./ConnectedAudioTestEndedFeedback.telemetry";
import { AudioTestEndedFeedback } from "./AudioTestEndedFeedback";

export const ConnectedAudioTestEndedFeedback: React.FC = () => {
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  // Callback to continue to "audio devices working correctly" page
  const resultsClearClick = useCallback(async () => {
    //log user reported mic or speaker working
    logAudioTestResult(true);

    //set mic and speaker result as working based on test result
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_MICROPHONE_RESULT,
      microphoneResult: { status: DeviceStatus.WORKING },
    });
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_SPEAKER_RESULT,
      speakerResult: { status: DeviceStatus.WORKING },
    });
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_AUDIO_TEST_STATE,
      audioTestState: AudioTestState.RESULT_FINISH_PROMPT,
    });
  }, [deviceTesterDispatch]);

  // Callback to continue to "audio devices working correctly" page
  const resultsUnclearClick = useCallback(async () => {
    //log user reported mic or speaker not working
    logAudioTestResult(false);

    //set mic and speaker result as working based on test result
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_MICROPHONE_RESULT,
      microphoneResult: {
        status: DeviceStatus.FAILED,
      },
    });
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_SPEAKER_RESULT,
      speakerResult: {
        status: DeviceStatus.FAILED,
      },
    });
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_AUDIO_TEST_STATE,
      audioTestState: AudioTestState.TEST_UNCLEAR,
    });
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_AUDIO_TEST_STATE,
      audioTestState: AudioTestState.TEST_UNCLEAR,
    });
  }, [deviceTesterDispatch]);

  // Callback to run test again
  const runTestAgain = useCallback(async () => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.RESULTS,
    });
  }, [deviceTesterDispatch]);

  return (
    <AudioTestEndedFeedback
      resultsClearClick={resultsClearClick}
      resultsUnclearClick={resultsUnclearClick}
      runTestAgain={runTestAgain}
    />
  );
};
